module.exports = __webpack_public_path__ + "img/gingercook.944c4f9a.png";